import { render, staticRenderFns } from "./ListRefaccionesWebApp.vue?vue&type=template&id=33fbccb8&"
import script from "./ListRefaccionesWebApp.vue?vue&type=script&lang=js&"
export * from "./ListRefaccionesWebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports